import { IonHeader,IonButtons,IonMenuButton, IonRow, IonCol, IonToolbar, IonIcon, IonModal, IonTitle, IonButton, IonContent } from "@ionic/react"
import './Ae2Header.css'
import User from "../User"
import { useSelector } from "react-redux"
import { selectUser } from "../../reducers/UserReducer"
import { isStaff } from "../extras/Functions"
import { useState } from "react"
import { isMobile } from "react-device-detect"
import { searchCircleOutline } from "ionicons/icons"
import SearchBarMain from "../SearchBarMain"
import { default as ask_alphie} from "../../AE2/static/icons/header/Help_Ask Alphie.svg"
import HeyAlphaModal from "./Modals/HeyAlphaModal"
import { useWindowWidth } from "../../utils/useWindowWidth"

const AlphaInsightsHeader: React.FC = () => {

  const [showSearchModal, setShowSearchModal] = useState(false)
  const [alphieModal, setAlphieModal] = useState(false)
  const user = useSelector(selectUser)
  
  const width = useWindowWidth()


    if (isMobile || width<768){
      return (
        <IonToolbar className="ai-toolbar">
          <IonButtons slot="start">
              <IonMenuButton />
            </IonButtons>
          <div style={{textAlign:'center'}}>Alpha Insights</div>
          <IonRow slot="end" className="ion-align-items-center">
              <IonIcon onClick={()=>setShowSearchModal(true)} style={{fontSize:'25px', margin:'0.1rem'}} src={searchCircleOutline}></IonIcon>
              <User/>
              <IonModal isOpen={showSearchModal} onDidDismiss={()=>setShowSearchModal(false)}>
                <IonHeader>
                  <IonToolbar>
                    <IonTitle>Search</IonTitle>
                      <IonButtons slot="end">
                        <IonButton onClick={() => setShowSearchModal(false)}>Close</IonButton>
                      </IonButtons>
                    </IonToolbar>                    
                  </IonHeader>
                <IonContent>
                  <SearchBarMain mobile={true}/>
                </IonContent>
              </IonModal>
            </IonRow>
        </IonToolbar>
      )
    }



    return (
      <>
        <IonHeader translucent={true}>
              <div className='top-header-AI'>
                  {/* <IonText className="pc-title-content" onClick={e => handleClick()}> Alpha Controls & Services Insights Updated</IonText> */}
                  <IonRow>
                    <IonCol size="10">
                      <div style={{height:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}>
                        {isStaff(user) ?
                        <div style={{ position:'relative',width:'100%',maxWidth: "700px"}}>
                          <SearchBarMain/>
                        </div>:
                        "Alpha insights" }
                      </div>
                    </IonCol>
                    <IonCol size="2">
                      <div style={{height:'100%',display:'flex',justifyContent:'end',alignItems:'center'}}>  
                        <IonButton className="alphie-btn" fill='clear' onClick={()=>setAlphieModal(true)}>
                          <IonIcon slot="icon-only" className="font-20pt" src={ask_alphie}></IonIcon>
                        </IonButton>
                        <User/>
                      </div>
                    </IonCol>
                  </IonRow>                
              </div>
              <HeyAlphaModal isOpen={alphieModal} onClose={()=>setAlphieModal(false)}/>
          </IonHeader>
      </>
    )
}

export default AlphaInsightsHeader